<template>
  <v-data-table :headers="headers" :items="scale_types">
    <template v-slot:top>
      <FormDialog :dialog="create_dialog" :close="closeCreateDialog" :title="modal_title">
        <FormScales :editData="scale_selected" :closeDialog="closeCreateDialog" />
      </FormDialog>

      <div class="d-flex justify-end">
        <v-btn color="green lighten-1" dark class="my-2" @click="openCreate">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Criar</v-btn
        >
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
    </template>
    
    <template v-slot:item.color="{ item }">
      <v-icon :color="item.color"> mdi-square </v-icon>
    </template>
  </v-data-table>
</template>







<script>
import { mapState } from 'vuex'
import FormDialog from '@/components/dialogs/FormDialog.vue'
import FormScales from './FormScales.vue'

export default {
  name: 'ScalesList',
  components: { FormDialog, FormScales },

  data: () => {
    return {
      scale_selected: {},
      create_dialog: false,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Sigla', value: 'initials' },
        { text: 'Escala', value: 'name' },
        { text: 'Carga Horaria', value: 'workload' },
        { text: 'Cor', value: 'color' },
        { text: 'Ações', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState('utils', ['scale_types']),
    modal_title() {
      if (this.scale_selected.name) {
        return 'Editar Escala'
      } else {
        return 'Cadastrar Escala'
      }
    },
  },
  methods: {
    openCreate() {
      this.create_dialog = true
      // console.log(this.scale_selected.name)
    },
    closeCreateDialog() {
      this.create_dialog = false
      this.scale_selected = {}
    },
    editItem(data) {
      this.scale_selected = data
      this.openCreate()
    },
  },
}
</script>
